import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Tooltip,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";
import { accessRole } from "../../../../helpers/access_role";

import moment from "moment";
import { CustomFileInput } from "../../../../helpers/ui/CustomFileInput";

var reformatType = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.retired_type_name;
    newObj["value"] = region.retired_type_uuid;
    return newObj;
  });
};

// format dd/mm/yyy
var format_dmy = function (tgl) {
  return moment(tgl).format("DD-MM-YYYY");
};

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      tooltipStyle: {
        marginBottom: 2,
        backgroundColor: "#000",
        color: "#FFF",
        border: "1px solid #000",
      },
      dataForm: {
        uuid: "",
        nip: "",
        nama: "",
        unit_kerja: "",
        jabatan: "",
        tmt_jabatan: "",
        tgl_pensiun: "",
        golongan: "",
        tgl_lahir: "",
        jenis_kelamin: "",
        tmt_pensiun: "",
        usia: "",
        usia_pensiun: "",
        sisa_masa_kerja: "",
        tusk: "",
        mpp: "",
        retired_type_name: "",
        retired_type_stop_name: "",
      },
      submission_uuid: "",
      typeItems: [],
      typeSelected: "",
      dokumen_persyaratan: [],
      documents: [],
      dms_documents: [],
      bankOption: [],
      bankSelected: null,
    };
  }

  submitData = async () => {
    let formData = generateFormData(
      this.state.dataForm,
      this.state.documents,
      this.state.dms_documents
    );
    formData.append(
      "retired_employee_uuid",
      document.getElementsByName("retired_employee_uuid")[0].value
    );
    formData.append(
      "retired_employee_retired_type_uuid",
      document.getElementsByName("retired_employee_retired_type_uuid")[0].value
    );
    formData.append("uuid", document.getElementsByName("uuid")[0].value);
    formData.append("tusk", document.getElementsByName("tusk")[0].value);
    formData.append("mpp", document.getElementsByName("mpp")[0].value);
    formData.append(
      "retired_employee_bank",
      document.getElementsByName("retired_employee_bank")[0].value
    );
    await this.updateBloc.fetchUpdate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  onChangeTypeSelected = (type) => {
    this.setState({
      typeSelected: type.value,
    });
  };

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  loadBank = async () => {
    this.setState({ loadingBank: true });
    await this.updateBloc.fetchBank();
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // load to form
            this.setState({
              dataForm: {
                uuid: response.retired_uuid,
                retired_employee_uuid: response.retired_employee_uuid,
                nip: response.retired_employee_nip,
                nama: response.retired_employee_name,
                unit_kerja: response.retired_employee_work_unit_name,
                jabatan: response.retired_employee_position_name,
                tmt_jabatan: format_dmy(response.retired_employee_position_tmt),
                tgl_pensiun: format_dmy(response.retired_employee_retired_date),
                golongan: response.retired_employee_level_name,
                tgl_lahir: format_dmy(response.retired_employee_birth_date),
                jenis_kelamin: response.gender_name,
                tmt_pensiun: format_dmy(
                  response.retired_employee_retired_date_tmt
                ),
                usia: response.employee_age,
                usia_pensiun: response.employee_age_retired,
                sisa_masa_kerja: response.employee_work_age,
                tusk: response.retired_employee_tusk,
                mpp: response.retired_employee_mpp,
                retired_type_name: response.retired_type_name,
                retired_type_stop_name: response.retired_type_stop_name,
                retired_employee_kppn_place:
                  response.retired_employee_kppn_place,
                retired_employee_bank: response.retired_employee_bank,
                retired_employee_bank_number:
                  response.retired_employee_bank_number,
              },
              bankSelected: response.retired_employee_bank,
              typeSelected: response.retired_employee_retired_type_uuid,
              submission_uuid: response.retired_employee_submission_uuid,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.typeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              typeItems: reformatType(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.documentChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            let documents = response.result.map((item) => "file-" + item.uuid);
            this.setState({
              dokumen_persyaratan: response.result,
              documents: documents,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.updateBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            bankOption: result.data.response.result,
            loadingBank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });
    this.updateBloc.fetchDocument({ uuid: queryParams.get("uuid") });
    this.updateBloc.fetchType();
    this.loadBank();
  }

  componentWillUnmount() {
    this.updateBloc.updateChannel?.unsubscribe();
    this.updateBloc.detailChannel?.unsubscribe();
    this.updateBloc.typeChannel?.unsubscribe();
    this.updateBloc.documentChannel?.unsubscribe();
    this.updateBloc.bankChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <style>
          {`
            .custom-arrow::before {
              content: "";
              position: absolute;
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
              border-right: 6px solid #000; /* Same color as tooltip background */
              top: 50%; /* Position arrow at the vertical center */
              left: -5px; /* Adjust position from the left */
              transform: translateY(-50%); /* Center the arrow vertically */
            }
          `}
        </style>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Edit Usulan Pemberhentian</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <AvField
                      name="uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.uuid}
                    />

                    <AvField
                      name="retired_employee_uuid"
                      type="hidden"
                      id="uuid"
                      value={this.state.dataForm.retired_employee_uuid}
                    />

                    <AvField
                      name="employee_uuid"
                      type="hidden"
                      className="form-control"
                      validate={{ required: { value: true } }}
                      id="employee_uuid"
                      value={this.state.dataForm.retired_employee_uuid}
                    />

                    <AvField
                      name="retired_employee_retired_type_uuid"
                      type="hidden"
                      id="uuid"
                      value={
                        this.state.dataForm.retired_employee_retired_type_uuid
                      }
                    />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        NIP
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nip"
                          id="nip"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.nip}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="nama"
                          id="nama"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.nama}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Unit Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="unit_kerja"
                          id="unit_kerja"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.unit_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="jabatan"
                          id="jabatan"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.jabatan}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Jabatan
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tmt_jabatan"
                          id="tmt_jabatan"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.tmt_jabatan}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Golongan
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="golongan"
                          id="golongan"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.golongan}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Lahir
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tgl_lahir"
                          id="tgl_lahir"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.tgl_lahir}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Kelamin
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="jenis_kelamin"
                          id="jenis_kelamin"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.jenis_kelamin}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Pemberhentian
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tgl_pensiun"
                          id="tgl_pensiun"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.tgl_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pemberhentian
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="tmt_pensiun"
                          id="tmt_pensiun"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.tmt_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Usia
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="usia"
                          id="usia"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.usia}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Usia Pemberhentian
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="usia_pensiun"
                          id="usia_pensiun"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.usia_pensiun}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Sisa Masa Kerja
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="sisa_masa_kerja"
                          id="sisa_masa_kerja"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.sisa_masa_kerja}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Pemberhentian
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="retired_type_name"
                          id="retired_type_name"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.retired_type_name}
                        />
                      </Col>
                      {/* <Col md="9">
                        <Select
                          readonly="readonly"
                          value={this.state.typeItems.filter(
                            (option) => option.value === this.state.typeSelected
                          )}
                          onChange={this.onChangeTypeSelected}
                          required="required"
                          options={this.state.typeItems}
                          classNamePrefix=""
                          placeholder="Pilih Jenis"
                          isDisabled={true}
                        />
                        <AvField
                          name="retired_employee_retired_type_uuid"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="retired_employee_retired_type_uuid"
                          value={this.state.typeSelected}
                        />
                      </Col> */}
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jenis
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder=""
                          name="retired_type_stop_name"
                          id="retired_type_stop_name"
                          readonly="readonly"
                          type="form-control"
                          className="form-control"
                          value={this.state.dataForm.retired_type_stop_name}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3">
                        <label className="col-form-label" id="label_tusk">
                          TUSK <span className="text-danger">*</span>
                        </label>
                        <Tooltip
                          style={this.state.tooltipStyle}
                          arrowClassName="custom-arrow"
                          placement="right"
                          isOpen={this.state["label_tusk"]}
                          target="label_tusk"
                          toggle={() => {
                            this.setState({
                              ["label_tusk"]: !this.state["label_tusk"],
                            });
                          }}
                        >
                          Belum Ada Tooltip
                        </Tooltip>
                      </Col>
                      <Col md="9">
                        <AvField
                          readonly="readonly"
                          name="tusk"
                          id="tusk"
                          placeholder="TUSK"
                          type="text"
                          errorMessage="TUSK"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          value={this.state.dataForm.tusk}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3">
                        <label className="col-form-label" id="label_mpp">
                          MPP <span className="text-danger">*</span>
                        </label>
                        <Tooltip
                          style={this.state.tooltipStyle}
                          arrowClassName="custom-arrow"
                          placement="right"
                          isOpen={this.state["label_mpp"]}
                          target="label_mpp"
                          toggle={() => {
                            this.setState({
                              ["label_mpp"]: !this.state["label_mpp"],
                            });
                          }}
                        >
                          Masa Persiapan Pensiun
                        </Tooltip>
                      </Col>

                      <Col md="9">
                        <AvField
                          readonly="readonly"
                          name="mpp"
                          id="mpp"
                          placeholder="MPP"
                          type="text"
                          errorMessage="MPP"
                          className="form-control"
                          // validate={{ required: { value: true } }}
                          value={this.state.dataForm.mpp}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_employee_kppn_place"
                        className="col-md-3 col-form-label"
                      >
                        Tempat KPPN
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Tempat KPPN"
                          name="retired_employee_kppn_place"
                          id="retired_employee_kppn_place"
                          type="text"
                          className="form-control"
                          errorMessage="Tempat KPPN"
                          value={
                            this.state.dataForm.retired_employee_kppn_place
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_employee_bank"
                        className="col-md-3 col-form-label"
                      >
                        Bank <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <Select
                          name="retired_employee_bank"
                          errorMessage="Pilih Bank"
                          placeholder="Pilih Bank"
                          options={this.state.bankOption}
                          onChange={(opt) =>
                            this.setState({ bankSelected: opt.value })
                          }
                          // defaultValue={
                          //   this.state.dataForm?.retired_employee_bank
                          // }
                          value={this.state.bankOption.filter(
                            (option) => option.value === this.state.bankSelected
                          )}
                          validate={{ required: { value: true } }}
                        />
                        {/* <AvField
                          placeholder="Bank"
                          name="retired_employee_bank"
                          id="retired_employee_bank"
                          type="text"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          errorMessage="Bank"
                          value={this.state.dataForm.retired_employee_bank}
                        /> */}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="retired_employee_bank_number"
                        className="col-md-3 col-form-label"
                      >
                        Nomor Rekening <span className="text-danger">*</span>
                      </label>
                      <Col md="9">
                        <AvField
                          placeholder="Nomor Rekning"
                          name="retired_employee_bank_number"
                          id="retired_employee_bank_number"
                          type="number"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          errorMessage="Nomor Rekening"
                          value={
                            this.state.dataForm.retired_employee_bank_number
                          }
                        />
                      </Col>
                    </Row>

                    <hr />
                    <h4>Dokumen Persyaratan</h4>
                    <br />
                    {this.state.dokumen_persyaratan.map((data, index) => {
                      return (
                        <Row className="mb-3">
                          <Col md="3">
                            <label
                              className="col-form-label"
                              id={`file-${data.uuid}`}
                            >
                              {data.label}{" "}
                              {data.is_required === 1 ? (
                                <span className="text-danger">*</span>
                              ) : (
                                ""
                              )}
                            </label>
                            <Tooltip
                              style={this.state.tooltipStyle}
                              arrowClassName="custom-arrow"
                              placement="right"
                              isOpen={this.state["file-" + data.uuid]}
                              target={`file-${data.uuid}`}
                              toggle={() => {
                                this.setState({
                                  ["file-" + data.uuid]:
                                    !this.state["file-" + data.uuid],
                                });
                              }}
                            >
                              {data.tooltip}
                            </Tooltip>
                          </Col>
                          <Col md="5">
                            <CustomFileInput
                              validate={{
                                required: {
                                  value:
                                    data.is_required === 1 &&
                                    data.path === null,
                                },
                              }}
                              name={`file-${data.uuid}`}
                              dms_name={`dms_${data.uuid}`}
                            />
                          </Col>
                          <Col md="4">
                            {data.template ? (
                              <>
                                {data.template !== "" ? (
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    class="btn btn-sm btn-primary"
                                    href={data.template}
                                  >
                                    <i className="uil-file-download"></i>{" "}
                                    Download Template
                                  </a>
                                ) : (
                                  "Tidak ada dokumen"
                                )}{" "}
                              </>
                            ) : null}

                            {data.path ? (
                              <>
                                {data.path !== "" ? (
                                  <a
                                    target="_blank"
                                    rel="noreferrer"
                                    class="btn btn-sm btn-primary"
                                    href={data.path}
                                  >
                                    <i className="uil-file-download"></i>{" "}
                                    Download File
                                  </a>
                                ) : (
                                  "Tidak ada dokumen"
                                )}
                              </>
                            ) : (
                              <a
                                href="#"
                                class="btn btn-sm btn-secondary disabled"
                              >
                                <i className="uil-file-download"></i> Download
                                File
                              </a>
                            )}
                          </Col>
                        </Row>
                      );
                    })}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link
                          to={`?pegawai&uuid=` + this.state.submission_uuid}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/file_persiapan_pensiun.html?pegawai&uuid=` +
              this.state.submission_uuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
